import { axiosInstance } from "../axios/axiosConfig";
import { SHOPPING_CART_API } from "../constants/api-constants";

const controller = "ShoppingCart";

export const getStudentOrderInfo = async () => {
  try {
    const response = await axiosInstance.get(`${controller}/GetStudentOrderInfo`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkout = async (data) => {
  try {
    const response = await axiosInstance.post(`${controller}/checkout`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addProductToShoppingCart = async (productId, quantity = null) => {
  try {
    const response = await axiosInstance.post(SHOPPING_CART_API.ADD_SHOPPING_CART_ITEM, {
      productId: productId,
      quantity: quantity
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductQuantityInShoppingCart = async (productId, quantity = null) => {
  try {
    const response = await axiosInstance.post(SHOPPING_CART_API.UPDATE_SHOPPING_CART_ITEM, {
      productId: productId,
      quantity: quantity
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getQuickBuyItem = async (productId, quantity) => {
  try {
    const response = await axiosInstance.get(`${controller}/quickByItem?productPublicId=${productId}&quantity=${quantity}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
